<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";

  export let showAddingSalesRepHelpModal: boolean;

  const dispatch = createEventDispatcher();

  function close() {
    showAddingSalesRepHelpModal = false;
    dispatch("close");
  }

</script>

<FizzStyles>
  <Modal
    bind:show={showAddingSalesRepHelpModal}
    fizzModal={true}
    size="small"
    closeOnBackgroundClick={true}
  >
    <header class="fizz-modal-header" data-testid="adding-sales-rep-help-modal">
      <h4 class="fizz-heading-4">Add a sales rep</h4>
      <button class="fizz-icon-button-small fizz-modal-toggle fizz-modal-close" on:click={close}>
        <Icon type="X" extraClassNames="fizz-text-brand" height="16" width="16" />
      </button>
    </header>

    <section class="fizz-modal-main fizz-text-medium">
      <p>
        In order to successfully send an order, Provi needs to know who to send it to. Provi sends
        your order to an actual person to process. That person can be your sales rep or customer
        service contact at a distributor.
      </p>
    </section>
    <section class="fizz-modal-main fizz-text-medium">
      <p>
        If you don’t have a distributor recipient for this order, contact the distributor to get
        assigned one or reach out to Provi customer success.
      </p>
    </section>
  </Modal>
</FizzStyles>
